import { BreadcrumbItem } from '@payaca/ambrosia';
import { HeaderTagType } from '@payaca/components/headerTag/HeaderTag';
import TabbedView from '@payaca/components/tabbedView/TabbedView';
import { FC, type JSX, PropsWithChildren } from 'react';

import AuthenticatedPageWrapper, {
  TProps as AuthenticatedPageWrapperProps,
} from '../authenticatedPageWrapper/AuthenticatedPageWrapper';

import './TabbedContentPageWrapper.sass';

type Props = Pick<
  AuthenticatedPageWrapperProps,
  'pageRouteId' | 'requiredRoles'
> & {
  className?: string;
  breadcrumbItems?: BreadcrumbItem[];
  tabbedContentConfig: {
    tabs: {
      content: JSX.Element;
      defaultSelected?: boolean | undefined;
      isDisabled?: boolean | undefined;
      title: string;
      label: string;
    }[];
    activeTabLabel?: string;
    onChangeTab: (label: string) => void;
  };
};

const TabbedContentPageWrapper: FC<PropsWithChildren<Props>> = ({
  tabbedContentConfig,
  className,
  breadcrumbItems,
  pageRouteId,
  requiredRoles,
  children,
}) => {
  return (
    <AuthenticatedPageWrapper
      breadcrumbItems={breadcrumbItems}
      pageRouteId={pageRouteId}
      requiredRoles={requiredRoles}
    >
      {children}
      <TabbedView
        tabs={tabbedContentConfig.tabs}
        titleHeaderTagType={HeaderTagType.H2}
        activeTabLabel={tabbedContentConfig.activeTabLabel}
        onChangeTab={tabbedContentConfig.onChangeTab}
      />
    </AuthenticatedPageWrapper>
  );
};

export default TabbedContentPageWrapper;
